import { Component } from '@angular/core';
import { fromSubscription } from '@app/subscription/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'pl-current-license',
  styleUrls: ['./current-license.component.scss'],
  template: `
    @if (license$ | async; as license) {
    <div class="current-license">
      <mat-icon>workspace_premium</mat-icon>
      <h4 class="pl-1 pr-4">{{ license }}</h4>
    </div>
    }
  `,
})
export class CurrentLicenseComponent {
  license$ = this.store.select(fromSubscription.selectCurrentLicenseName);

  constructor(private store: Store) {}
}
